import React, { FC, useEffect, useState } from 'react';
import CheckCoverageComponent from './CheckCoverage';
import Styles from './CoverCheckWrapper.module.scss';
import { viewport } from '../../utils/utils';


const CheckCoverage: FC<any> = ({
  content,
  isFetchingLineCheck,
  overlayIsOpen,
  externalHandleModal,
  productName,
  onSuccess,
  lineCheckOnClear,
  onCreateCart
}) => {
  const openInOverlay = overlayIsOpen ? overlayIsOpen : content?.openInOverlay;
  content['openInOverlay'] = true;
  const [openModal, setOpenModal] = useState(overlayIsOpen);

  const handleModal = () => {
    setOpenModal(!openModal);
    externalHandleModal && externalHandleModal(!openModal);
  };
  const viewPort = viewport();
  const isMobile = viewPort === 'mobile' ? true : false;

  useEffect(() => {
    setOpenModal(overlayIsOpen);
  }, [overlayIsOpen]);

  return (
    <div>
      {isMobile && openModal && openInOverlay ? (
        <div className={Styles['overlay']}>
          <div className={Styles['modal-content']}>
            <CheckCoverageComponent
              content={content}
              handleModal={handleModal}
              openModal={openModal}
              isFetchingLineCheck={isFetchingLineCheck}
              productName={productName}
              onSuccess={onSuccess}
              lineCheckOnClear={lineCheckOnClear}
              onCreateCart={onCreateCart}
            />
          </div>
        </div>
      ) : (
        <CheckCoverageComponent
          content={content}
          isFetchingLineCheck={isFetchingLineCheck}
          onSuccess={onSuccess}
          lineCheckOnClear={lineCheckOnClear}
        />
      )}
    </div>
  );
};

export default CheckCoverage;
